// src/components/PrivacyPolicy.jsx
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div
      style={{
        backgroundColor: "#000", // Full black background
        color: "#fff", // White text
        minHeight: "100vh", // Cover full screen height
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          height: "90vh", // Scrollable height
          overflowY: "auto",
          padding: "40px",
          backgroundColor: "#111", // Slightly lighter black box
          borderRadius: "10px",
          boxShadow: "0 0 10px rgba(255, 255, 255, 0.1)",
        }}
        className="scrollable-box"
      >
        <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
          Privacy Policy
        </h1>

        <p>
          Your privacy is important to us. This Privacy Policy explains how we
          collect, use, and protect your personal information when you use our
          website or services.
        </p>

        <h2>Information We Collect</h2>
        <p>
          We may collect personal information such as your name, email address,
          and usage data when you interact with our website. We also collect
          non-personal information such as browser type, device information, and
          IP address for analytics purposes.
        </p>

        <h2>How We Use Your Information</h2>
        <p>
          Your information is used to improve our services, respond to
          inquiries, personalize your experience, and communicate updates. We do
          not sell or share your personal data with third parties for marketing
          purposes.
        </p>

        <h2>Cookies</h2>
        <p>
          We use cookies and similar technologies to enhance your browsing
          experience and analyze website traffic. You can manage your cookie
          preferences in your browser settings.
        </p>

        <h2>Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your
          information from unauthorized access, disclosure, alteration, or
          destruction.
        </p>

        <h2>Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for their privacy practices. Please review their policies
          before providing any personal information.
        </p>

        <h2>Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Any changes will be
          posted on this page with the updated effective date.
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have questions or concerns about this Privacy Policy, please
          contact us at:
          <br />
          <strong>Email:</strong> hello@stratxcel.ai
        </p>
      </div>

      {/* Custom scrollbar for WebKit browsers */}
      <style>{`
        .scrollable-box::-webkit-scrollbar {
          width: 8px;
        }
        .scrollable-box::-webkit-scrollbar-track {
          background: #111;
        }
        .scrollable-box::-webkit-scrollbar-thumb {
          background-color: #555;
          border-radius: 4px;
        }
        .scrollable-box::-webkit-scrollbar-thumb:hover {
          background-color: #888;
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy;
